export class FileSectionTypes {
  static Marketing = Boo.Objects.Enums.FileSectionTypesEnum.Marketing;
  static LocalProfile = Boo.Objects.Enums.FileSectionTypesEnum.LocalProfile;
  static General = Boo.Objects.Enums.FileSectionTypesEnum.General;
  static BoostSite = Boo.Objects.Enums.FileSectionTypesEnum.BoostSite;
  static Ranks = Boo.Objects.Enums.FileSectionTypesEnum.Ranks;
  static KeywordResearch = Boo.Objects.Enums.FileSectionTypesEnum.KeywordResearch;
}